import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'reactstrap';
import coreService from '../../services/core';
import userService from '../../services/user';


export default class UserDetailsList extends Component {

    toggleRemovedFromEmailList = async (u) => {
        const isRemoved = !u.IsRemovedFromEmailList;
        await userService.setRemovedFromEmailList(u.UserId, isRemoved);
        u.IsRemovedFromEmailList = isRemoved;
        this.forceUpdate();
    }

    render() {
        const { users } = this.props;

        return (
            <div>
                <Table responsive>
                    <tbody>
                        {users.map(u => (
                            <tr key={`user-${u.UserId}`}>
                                <td width="10%"
                                    tag="a"
                                    className="user-list-item"
                                    href={`/user/${u.UserId}`}
                                    >
                                    {coreService.userTypes[u.UserTypeId.toString()].typeStringProper} - {u.FirstName} {u.LastName}
                                </td>
                                <td width="5%">
                                    <a tag="a"
                                        className="btn btn-outline-secondary"
                                        href={`/edituser/${u.UserId}`}
                                    >Edit</a>
                                </td>
                                <td width="10%">
                                    <Button
                                        color={u.IsRemovedFromEmailList ? 'secondary' : 'outline-secondary'}
                                        onClick={() => this.toggleRemovedFromEmailList(u)}
                                    >
                                        {u.IsRemovedFromEmailList ? 'Add Back To Email List' : 'Remove From Email List'}
                                    </Button>
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>);
    }
}

UserDetailsList.propTypes = {
    users: PropTypes.arrayOf(PropTypes.object)
};

UserDetailsList.defaultProps = {
    users: []
};
